"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MBLabel = exports.IMBLabelVariant = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importDefault(require("styled-components"));
var IMBLabelVariant;
(function (IMBLabelVariant) {
    IMBLabelVariant[IMBLabelVariant["tuscany"] = 0] = "tuscany";
    IMBLabelVariant[IMBLabelVariant["red"] = 1] = "red";
    IMBLabelVariant[IMBLabelVariant["grey"] = 2] = "grey";
    IMBLabelVariant[IMBLabelVariant["blue"] = 3] = "blue";
    IMBLabelVariant[IMBLabelVariant["green"] = 4] = "green";
    IMBLabelVariant[IMBLabelVariant["yellow"] = 5] = "yellow";
})(IMBLabelVariant = exports.IMBLabelVariant || (exports.IMBLabelVariant = {}));
var MBLabel = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? IMBLabelVariant.yellow : _b, children = _a.children;
    return jsx_runtime_1.jsx(StyledLabel, __assign({ variant: variant }, { children: children }), void 0);
};
exports.MBLabel = MBLabel;
var StyledLabel = styled_components_1.default('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 6.5px 12px;\n  display: inline-block;\n  border-radius: 4px;\n  background: ", ";\n"], ["\n  padding: 6.5px 12px;\n  display: inline-block;\n  border-radius: 4px;\n  background: ",
    ";\n"])), function (_a) {
    var variant = _a.variant, theme = _a.theme;
    switch (variant) {
        case IMBLabelVariant.yellow:
            return theme.colors.primary.IceterineYellow50;
        case IMBLabelVariant.tuscany:
            return theme.colors.secondary.TuscanyPink75;
        case IMBLabelVariant.red:
            return theme.colors.danger.Red50;
        case IMBLabelVariant.grey:
            return theme.colors.basic.Grey20;
        case IMBLabelVariant.blue:
            return theme.colors.secondary.VividSkyBlue75;
        case IMBLabelVariant.green:
            return theme.colors.secondary.AquamarineGreen100;
        default:
            return '';
    }
});
var templateObject_1;
//# sourceMappingURL=MBLabel.js.map